import { useRef , useEffect, useState} from 'react';
import {LoadingDiv } from '@components/LoadingDiv';
import { Markdown2Svg } from '@components/Markdown2Svg';
import useGetPolicyTimelineMindmap from '../../hooks/useGetPolicyTimelineMindmap';
import { ErrorBoundary } from '@components/ErrorBoundary/index';
import { useConfig } from '../../../../contexts/ConfigContext'; // ✅ 添加配置导入

export const MindTree = (props) => {
    const {fileName,setMdTxt,setFileName,fileId} = props
    const [viewPolicy, setViewPolicy] = useState()
    const {getPolicyTimelineMindmapAction, policyTimelineMindmapLoading} = useGetPolicyTimelineMindmap();
    const { theme } = useConfig(); // ✅ 获取主题配置

    useEffect(()=>{
        if(fileName){
            getPolicyTimelineMindmapAction({policy_title:fileName,policy_id:fileId})
            .then(res=>{setViewPolicy(res)})
        }
    },[fileName])

    return (
        <>
            <div 
                className='relative p-4 h-full'
                style={{
                    // ✅ 使用环境配置的主题色
                    '--markmap-color-1': theme.primary,
                    '--markmap-color-2': theme.primary, 
                    '--markmap-color-3': `${theme.primary}CC`,
                    '--markmap-color-4': `${theme.primary}CC`,
                    '--markmap-color-5': `${theme.primary}99`,
                    '--markmap-color-6': `${theme.primary}99`,
                }}
            >
                <style jsx>{`
                    /* 连接线颜色 */
                    .markmap-link {
                        stroke: ${theme.primary} !important;
                        stroke-width: 2px;
                        opacity: 0.8;
                    }
                    
                    /* 节点圆圈颜色 */
                    .markmap-node > circle {
                        fill: ${theme.primary} !important;
                        stroke: ${theme.primary} !important;
                    }
                    
                    /* 文字下面的横线/边框颜色 */
                    .markmap-node > rect {
                        fill: ${theme.primary} !important;
                        stroke: ${theme.primary} !important;
                    }
                    
                    /* 文字颜色 */
                    .markmap-node text {
                        fill: ${theme.text} !important;
                    }
                    
                    /* 悬停效果 */
                    .markmap-node:hover > circle {
                        fill: ${theme.primaryHover} !important;
                        stroke: ${theme.primaryHover} !important;
                    }
                    
                    .markmap-node:hover > rect {
                        fill: ${theme.primaryHover} !important;
                        stroke: ${theme.primaryHover} !important;
                    }
                `}</style>
                
                {
                    fileName &&
                    <>
                    {
                        policyTimelineMindmapLoading ? 
                        <LoadingDiv/>
                        :
                        <ErrorBoundary>
                            <Markdown2Svg
                                setFileName={setFileName}
                                fileName={fileName}
                                setMdTxt={setMdTxt}
                                txt={viewPolicy?.policy_mind_map?.replace(/\>+/g, '-') ?? ''}
                            />
                        </ErrorBoundary>
                    }
                    </>
                }
            </div>
        </>
    )
}